import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  ModalDismissReasons,
  NgbDateStruct,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { ChangePasswordModel } from "../models/ChangePasswordModel";
import { Brands, ListData } from "../models/ListData";
import { updateProfileModel } from "../models/updateProfileModel";
import { AccountService } from "../services/account.service";
import { CampaignService } from "../services/campaign.service";
import { SettingService } from "../services/setting.service";
import { UpdateProfileService } from "../services/update-profile.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-update-profile",
  templateUrl: "./update-profile.component.html",
  styleUrls: ["./update-profile.component.scss"],
})
export class UpdateProfileComponent implements OnInit {
  active = 1;
  model: NgbDateStruct | null = null;
  today: NgbDateStruct;
  PhonesType: string[] = ["Android", "IOS"];
  profile = new updateProfileModel();
  citiesList: ListData[];
  Brands: Brands[];
  Models: ListData[];
  areas: ListData[];
  // cities:string[];
  HavenotMobile: boolean = true;
  hearAbout: boolean = false;
  carBrand: boolean = false;
  carModel: boolean = false;
  oilProduct: boolean = false;
  haveSmartPhone: boolean = false;
  mobileType: boolean = false;
  resetpassword: ChangePasswordModel = new ChangePasswordModel();
  enableEditMode: boolean = false;
  disableSaveBtn: boolean = false;
  closeResult = "";

  constructor(
    public accountService: AccountService,
    public settingService: SettingService,
    public updateProfileService: UpdateProfileService,
    public router: Router,
    public campaignService: CampaignService,
    public datepipe: DatePipe,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    this.settingService.pageName = "updateProfile";
    this.reload();
  }

  ngOnInit() {
    this.updateProfileService.getProfileData().subscribe((userData) => {
      this.profile = userData;
      const birthDate =
        userData.birthdate !== null ? new Date(userData.birthdate) : null;
      this.getCities();
      this.GetAreasByCityId(userData.cityId);
      this.model = this.fromModel(birthDate);
      this.changeHavePhoneNum(this.profile.haveSmartPhone);

      this.campaignService.getActiveCampaign().subscribe((res) => {
        if (res != null) {
          this.haveSmartPhone = res.campaignFields.find(
            (d) => d.fieldName == "HaveSmartPhone"
          ).visibility;
          this.mobileType = res.campaignFields.find(
            (d) => d.fieldName == "MobileType"
          ).visibility;
          this.hearAbout = res.campaignFields.find(
            (d) => d.fieldName == "HearAbout"
          ).visibility;
          this.carBrand = res.campaignFields.find(
            (d) => d.fieldName == "BrandId"
          ).visibility;
          this.carModel = res.campaignFields.find(
            (d) => d.fieldName == "ModelId"
          ).visibility;
          this.oilProduct = res.campaignFields.find(
            (d) => d.fieldName == "OilProduct"
          ).visibility;
          this.mobileType ? (this.haveSmartPhone = true) : null;
          if (this.carBrand) {
            this.GetBrands();
          }
        }
      });
    });
  }

  getCities() {
    this.accountService.GetCitiesList().subscribe((res) => {
      this.citiesList = res;
    });
  }

  GetAreasByCityId(id: number) {
    this.accountService.GetAreasByCityId(id).subscribe((res) => {
      this.areas = res;
    });
  }

  GetBrands() {
    this.accountService.GetBrands().subscribe((res) => {
      this.Brands = res;
      this.GetModelList(this.profile.brandId);
    });
  }

  GetModelList(brandId: number) {
    if (this.Brands.find((s) => s.id == brandId).models)
      this.Models = this.Brands.find((s) => s.id == brandId).models;
  }

  changeHavePhoneNum(option: any) {
    option = JSON.parse(option);
    // option == true ? this.HavenotMobile =!option : this.HavenotMobile =option;
    this.profile.haveSmartPhone = option;
    this.HavenotMobile = !option;
    if (!option) {
      this.profile.mobileType = "";
    }
  }

  changeProfile() {
    this.disableSaveBtn = true;
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = "";
    this.profile.birthdate = new Date(
      this.model["year"],
      this.model["month"] - 1,
      this.model["day"] + 1
    );
    this.profile.username = this.updateProfileService.getUserMobileNumber();
    this.updateProfileService.updateProfile(this.profile).subscribe(
      (res) => {
        this.settingService.isError = false;
        this.settingService.loading = false;
        this.toastr.success(
          this.translateService.instant("app.toastr.success.message"),
          this.translateService.instant("app.toastr.success.title"),
          {
            positionClass: "toast-bottom-right",
          }
        );
        this.enableEditMode = false;
        //this.router.navigate(['home']);
        this.disableSaveBtn = false;
      },
      (err) => {
        this.settingService.isError = false;
        this.settingService.message = err.error.message;
        this.toastr.error(
          this.translateService.instant("app.toastr.fail.message"),
          this.translateService.instant("app.toastr.fail.title"),
          {
            positionClass: "toast-bottom-right",
          }
        );

        this.disableSaveBtn = false;
      }
    );
  }

  changePassword() {
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = "";
    this.resetpassword.token = localStorage.Registertoken;
    this.accountService.changePassword(this.resetpassword).subscribe(
      (res) => {
        this.settingService.loading = false;
        this.settingService.isError = false;
        this.router.navigate(["login"]);
      },
      (error) => {
        this.settingService.loading = false;
        this.settingService.isError = true;
        this.settingService.message = error.error.message;
      }
    );
  }

  disableDate() {
    return false;
  }

  fromModel(date: Date): NgbDateStruct {
    return date
      ? {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
        }
      : null;
  }

  toModel(date: NgbDateStruct): Date {
    return date ? new Date(date.year, date.month - 1, date.day) : null;
  }

  reload() {
    this.settingService.languageEvent.subscribe((res) => {
      this.getCities();
      this.GetAreasByCityId(this.profile.cityId);
      this.GetBrands();
    });
  }

  deleteAccount() {
    this.settingService.loading = true;
    this.settingService.isError = false;
    this.settingService.message = "";
    this.accountService.deleteAccount(localStorage.Registertoken).subscribe(
      (result) => {
        this.settingService.loading = false;
        this.settingService.isError = false;
        this.router.navigate(["login"]);
      },
      (error) => {
        this.settingService.loading = false;
        this.settingService.isError = true;
        this.settingService.message = error.error.message;
      }
    );
  }

  openConFirmDelete(deleteContent) {
    this.modalService
      .open(deleteContent, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
